export const typeOptions = [
    {key: 'NORMAL', value: 'Normal'},
    {key: 'RETURN', value: 'Devolución'}
];

export const statusOptions = [
    {key: 'CREATED', value: 'Creada'},
    {key: 'ISSUED', value: 'Remesada'},
    {key: 'POSTED', value: 'Contabilizada'}
];